import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricsCard = ({ 
  title, 
  value, 
  subtitle = "", 
  icon, 
  trend = null, 
  trendDirection = "up",
  color = "primary",
  className = ""
}) => {
  const colorClasses = {
    primary: "text-primary bg-primary/10",
    success: "text-success bg-success/10",
    warning: "text-warning bg-warning/10",
    error: "text-error bg-error/10",
    secondary: "text-secondary bg-secondary/10"
  };

  const trendColors = {
    up: "text-success",
    down: "text-error",
    neutral: "text-muted-foreground"
  };

  const trendIcons = {
    up: "TrendingUp",
    down: "TrendingDown",
    neutral: "Minus"
  };

  return (
    <div className={`bg-card border border-border rounded-lg p-6 space-y-4 ${className}`}>
      <div className="flex items-center justify-between">
        <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${colorClasses?.[color]}`}>
          <Icon name={icon} size={24} />
        </div>
        {trend !== null && (
          <div className={`flex items-center space-x-1 ${trendColors?.[trendDirection]}`}>
            <Icon name={trendIcons?.[trendDirection]} size={16} />
            <span className="text-sm font-medium">{trend}%</span>
          </div>
        )}
      </div>
      <div className="space-y-1">
        <div className="text-2xl font-bold text-foreground font-mono">
          {value}
        </div>
        <div className="text-sm font-medium text-foreground">
          {title}
        </div>
        {subtitle && (
          <div className="text-xs text-muted-foreground">
            {subtitle}
          </div>
        )}
      </div>
    </div>
  );
};

export default MetricsCard;